import React, { FC } from 'react';
import { ReactComponent as NoAccountsLightIcon } from '../../../../assets/images/multiAccount/noAccountsLight.svg';
import { ReactComponent as NoAccountsDarkIcon } from '../../../../assets/images/multiAccount/noAccountsDark.svg';
import { useAppSelector } from '../../../../hooks/redux';

interface NoAccountsIconProps {
  className?: string;
}

const defaultProps = {
  className: '',
};

export const NoAccountsIcon: FC<NoAccountsIconProps> = ({ className }) => {
  const { theme } = useAppSelector((state) => state.appReducer);

  const getIcon = (colorTheme: string) => {
    switch (true) {
      case colorTheme === 'light': {
        return <NoAccountsLightIcon className={className} />;
      }
      case colorTheme === 'dark': {
        return <NoAccountsDarkIcon className={className} />;
      }
      default: {
        return <NoAccountsLightIcon className={className} />;
      }
    }
  };

  return getIcon(theme);
};

NoAccountsIcon.defaultProps = defaultProps;
